import { useCallSettings } from 'worker-connection-library/hooks/useWidgetDetails';
import { useProviderDetails } from 'worker-connection-library/hooks/useProviderDetails';
import { useMemo } from 'react';
import { Metrics, INSTALLED_CALLING_SETTINGS_MIGRATION_FAILED } from 'calling-remote-common/utils/Metrics';
export const useInstalledCallingSettings = () => {
  const {
    providerDetails
  } = useProviderDetails();
  const installedCallingSettingsFromProviderDetails = providerDetails === null || providerDetails === void 0 ? void 0 : providerDetails.installedCallingSettings;
  const {
    installedCallingSettings: installedCallingSettingsFromCallSettings
  } = useCallSettings();
  const installedCallingSettings = useMemo(() => {
    if (!installedCallingSettingsFromProviderDetails && installedCallingSettingsFromCallSettings) {
      Metrics.counter(INSTALLED_CALLING_SETTINGS_MIGRATION_FAILED).increment();
      return installedCallingSettingsFromCallSettings;
    }
    return installedCallingSettingsFromProviderDetails;
  }, [installedCallingSettingsFromProviderDetails, installedCallingSettingsFromCallSettings]);
  return installedCallingSettings;
};